angular.module('com.vmware.vsphere.client.host')
      .constant('helpConstants', {
         EDIT_DEFAULT_VM_COMPATIBILITY_ID: "com.vmware.vsphere.vm_admin.doc.vc_312"
      });
